module.exports = __webpack_public_path__ + "img/bargain_background.656195b5.png";